import api from "./utils/api";
import { getAuthToken } from "./utils/tokens";

const createCoupon = async (couponData) => {
  try {
    const token = getAuthToken();
    const data = await api.post("/coupon/create", couponData, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return data.data;
  } catch (err) {
    throw err;
  }
};

const getCoupons = async () => {
  try {
    const token = getAuthToken();
    const data = await api.get("/coupon", {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return data.data;
  } catch (err) {
    throw err;
  }
};

const getActiveCoupons = async () => {
  try {
    const token = getAuthToken();
    const data = await api.get("/coupon-active", {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return data.data;
  } catch (err) {
    throw err;
  }
};

const updateCoupon = async (updatedData, couponId) => {
  try {
    const token = getAuthToken();
    const data = await api.put(`/coupon/${couponId}`, updatedData, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return data.data;
  } catch (err) {
    throw err;
  }
};

const deleteCoupon = async (couponId) => {
  try {
    const token = getAuthToken();
    await api.delete(`/coupon/${couponId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  } catch (err) {
    throw err;
  }
};

const applyCoupon = async (couponCode) => {
  try {
    const token = getAuthToken();
    const data = await api.post(
      "/cart/apply-coupon",
      { couponCode },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return data.data;
  } catch (err) {
    throw err;
  }
};

export {
  createCoupon,
  getCoupons,
  getActiveCoupons,
  updateCoupon,
  deleteCoupon,
  applyCoupon,
};
